<template>
	<div class="syscheck-container">
		<div
			class="vr-candash-tabs-newcard"
			:class="isFromAiInterview ? 'from-ai' : ''"
		>
			<div
				v-if="isFromAiInterview"
				id="hideinmobile"
				class="cand-header d-flex mb-2"
			>
				<img
					class="mr-3 d-flex pointer"
					src="../../../../assets/img/homepage/back-arrow-blue.svg"
					alt=""
					@click="$router.go(-1)"
				/>
				Mock AI Interview
			</div>
			<div :class="isFromAiInterview ? 'parent-from-ai' : ''">
				<div
					class="pr-1"
					:class="{
						'from-ai-width': isFromAiInterview,
						'card-blur': !isLaptop && isFromAiInterview && showRules,
					}"
				>
					<div
						v-if="!isFromAiInterview"
						class="candash-bold-black-txt-7 d-flex align-items-center"
					>
						<img
							id="hideinmobile"
							@click="gobcktoPreview()"
							class="mr-2 pointer"
							src="../../../../assets/newdesign/videoresume/blueBackTick.svg"
							alt=""
						/>Create a Video Snapshot
						<img
							id="hideinlaptop"
							@click="gobcktoPreviewMobile()"
							class="grey-cross"
							src="@/assets/newbuilder/grey-cross.svg"
							alt=""
						/>
					</div>
					<div
						id="hideinmobile"
						v-if="candidateInfoState.profileName && !isFromAiInterview"
						class="mt-3 mb-1 rec-title-3 d-flex align-items-center"
					>
						<img
							src="../../../../assets/newdesign/dashboard/svg-resume.svg"
							alt=""
						/>
						{{ candidateInfoState.profileName }}
					</div>

					<div class="d-flex vr-flex justify-content-between mt-3 ml-3">
						<div class="w63">
							<div class="sc-black">
								<video style="object-fit: unset; transform: scaleX(-1)" ref="camera" class="w-100 h-100"
									id="proctor" autoplay muted playsinline></video>
								<canvas id="proctoring" class="w-100 h-100" hidden> </canvas>
								<audio autoplay></audio>
								<div v-if="isDisabled()" class="enable-txt">
									<img
										class="mr-1"
										src="../../../../assets/mainProfile/white-alert.svg"
										alt=""
									/>
									Enable System Permission
								</div>
							</div>
							<div
								class="d-flex align-items-end justify-content-between position-relative mt-2 vr-flex-3 height-50"
							>
								<div>
									<div>
										<div v-if="!toggle" style="margin-top: 28px">
											<div class="microphone-class"></div>
										</div>
										<div v-else>
											<canvas
												ref="waveformCanvas"
												width="280"
												height="30"
											></canvas>
										</div>
									</div>
									<div
										class="candash-modal-label"
										:style="!disabled ? 'margin-top: 6px;' : ''"
									>
										Check your Microphone and Speaker
									</div>
								</div>
								<div class="">
									<div v-if="!disabled" v-show="true">
										<b-button
											class="candash-cancelBtn"
											id="click"
											@click="
												startAudioCheck();
												toggle = true;
											"
											>Start Mic/Speaker Test</b-button
										>
									</div>
									<div v-else v-show="true">
										<b-button
											class="candash-cancelBtn"
											id="click"
											@click="
												stoppaudioStream();
												toggle = false;
											"
										>
											Stop Checking
										</b-button>
									</div>
								</div>
							</div>
						</div>
						<div class="sp-right">
							<div class="rec-title-3">
								System Permissions<span id="hideinlaptop"> Required</span>
							</div>
							<div class="mt-3 vr-flex-2">
								<div class="d-flex align-items-center">
									<img
										class="mr-2"
										src="../../../../assets/newdesign/videoresume/cam.svg"
										alt=""
									/>
									<div class="ml-2 new-black-txt">Video</div>
								</div>
								<div id="hideinmobile" class="topDiv pointer mt-2 pr-2">
									<div
										@click="camera = !camera"
										:class="
											VideoDevice.length === 0
												? 'sp-input d-flex justify-content-end'
												: 'sp-input d-flex justify-content-between'
										"
										v-closable="{
											exclude: ['dropdown1'],
											handler: 'hideCamera',
										}"
										ref="dropdown1"
									>
										<div class="w85 text-truncate">
											{{ selectedCamera }}
										</div>
										<img
											src="../../../../assets/icons/candDashboard/greenDownArrow.svg"
											alt=""
										/>
									</div>
									<span class="sc-alert-txt" v-if="VideoDevice.length === 0"
										>Camera is not available</span
									>
									<div
										v-if="camera && VideoDevice.length > 0"
										class="position-absolute sys-parent sp-top"
										style="z-index: 5"
										@click.stop=""
									>
										<div class="vs-dropdown-container">
											<div
												id="cameras-list"
												v-for="(cameraoption, index) in VideoDevice"
												:key="index"
												@click="handleSuccess(cameraoption)"
											>
												<div
													class="w-100"
													:class="
														selectedCamera === cameraoption.text
															? 'vs-dropdown-text-active'
															: 'vs-dropdown-text'
													"
												>
													{{ cameraoption.text }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div id="hideinlaptop">
									<b-form-checkbox
										v-model="cameraActive"
										switch
										class="mb-profile-switch"
										@change="toggleCamera()"
									></b-form-checkbox>
								</div>
							</div>
							<div class="mt-4 vr-flex-2">
								<div class="d-flex align-items-center">
									<img
										class="mr-2"
										src="../../../../assets/newdesign/videoresume/mic.svg"
										alt=""
									/>
									<div class="ml-2 new-black-tx">Microphone</div>
								</div>
								<div id="hideinmobile" class="topDiv pointer mt-2 pr-2">
									<div
										:class="
											AudioDevice.length === 0
												? 'sp-input d-flex justify-content-end'
												: 'sp-input d-flex justify-content-between'
										"
										@click="mic = !mic"
										v-closable="{
											exclude: ['dropdown2'],
											handler: 'hideMic',
										}"
										ref="dropdown2"
									>
										<div class="w85 text-truncate">
											{{ selectedMic }}
										</div>
										<img
											src="../../../../assets/icons/candDashboard/greenDownArrow.svg"
											alt=""
										/>
									</div>
									<span v-if="AudioDevice.length === 0" class="sc-alert-txt"
										>Microphone is not available</span
									>
									<div
										v-if="mic && AudioDevice.length > 0"
										class="position-absolute sys-parent sp-top"
										style="z-index: 5"
										@click.stop=""
									>
										<div class="vs-dropdown-container">
											<div
												v-for="(micoption, index) in AudioDevice"
												:key="index"
												@click="handleSuccessaudio(micoption)"
											>
												<div
													class="w-100"
													:class="
														selectedMic === micoption.text
															? 'vs-dropdown-text-active'
															: 'vs-dropdown-text'
													"
												>
													{{ micoption.text }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div id="hideinlaptop">
									<b-form-checkbox
										v-model="micActive"
										switch
										class="mb-profile-switch"
										@change="toggleMic"
									></b-form-checkbox>
								</div>
							</div>
							<div v-if="!isMacOrIOS" class="mt-4 vr-flex-2">
								<div class="d-flex align-items-center">
									<img
										class="mr-2"
										src="../../../../assets/newdesign/videoresume/speaker.svg"
										alt=""
									/>
									<div class="ml-2 new-black-tx">Speaker</div>
								</div>
								<div id="hideinmobile" class="topDiv pointer mt-2 pr-2">
									<div
										@click="speaker = !speaker"
										v-closable="{
											exclude: ['dropdown3'],
											handler: 'hideSpeaker',
										}"
										ref="dropdown3"
										:class="
											OutputDevice.length === 0
												? 'sp-input d-flex justify-content-end'
												: 'sp-input d-flex justify-content-between'
										"
									>
										<div class="w85 text-truncate">
											{{ selectedSpeaker }}
										</div>
										<img
											src="../../../../assets/icons/candDashboard/greenDownArrow.svg"
											alt=""
										/>
									</div>
									<span v-if="OutputDevice.length === 0" class="sc-alert-txt"
										>Speaker is not available</span
									>
									<div
										v-if="speaker && OutputDevice.length > 0"
										class="position-absolute sys-parent sp-top"
										style="z-index: 5"
										@click.stop=""
									>
										<div class="vs-dropdown-container">
											<div
												id="speaker-list"
												v-for="(speakeroption, index) in OutputDevice"
												:key="index"
												@click="speakeroutput(speakeroption)"
											>
												<div
													class="w-100"
													:class="
														selectedSpeaker === speakeroption.text
															? 'vs-dropdown-text-active'
															: 'vs-dropdown-text'
													"
												>
													{{ speakeroption.text }}
												</div>
											</div>
										</div>
									</div>
								</div>
								<div id="hideinlaptop">
									<b-form-checkbox
										v-model="speakerActive"
										switch
										class="mb-profile-switch"
										@change="toggleSpeaker"
									></b-form-checkbox>
								</div>
							</div>
							<div class="dash-border mt-4" id="hideinlaptop"></div>
						</div>
					</div>
				</div>
				<div v-if="isFromAiInterview && showRules" class="from-ai-right-cont">
					<div
						@click="$router.push({ name: 'InterviewOngoing' })"
						class="fam-lato fw-M fs-20 mob-fs-18 text-blue d-flex align-items-center justify-content-md-center justify-content-sm-start gap-2"
					>
						<img
							src="../../../../assets/img/aiInterview/skill-check.svg"
							alt=""
						/>Rules & Regulations:-
					</div>
					<div id="hideinmobile" class="dashed-div"></div>
					<div class="mob-rules-overflow">
						<div class="d-flex justify-content-center mt-4">
							<img
								src="../../../../assets/img/aiInterview/rules-back.svg"
								alt=""
							/>
						</div>
						<div class="fam-mont fw-LM fs-14 text-darkgrey d-flex gap-2 mt-4">
							<div>
								<img src="../../../../assets/img/aiInterview/dots.svg" alt="" />
							</div>
							<div>You can purchase mock interviews after this trial.</div>
						</div>
						<div class="fam-mont fw-LM fs-14 text-darkgrey d-flex gap-2 mt-4">
							<div>
								<img src="../../../../assets/img/aiInterview/dots.svg" alt="" />
							</div>
							<div>
								The interview will last for 15 minutes. Once started, it cannot
								be paused.
							</div>
						</div>
						<div class="fam-mont fw-LM fs-14 text-darkgrey d-flex gap-2 mt-4">
							<div>
								<img src="../../../../assets/img/aiInterview/dots.svg" alt="" />
							</div>
							<div>
								The interviewer's preferred language for communication is
								English.
							</div>
						</div>
						<div class="fam-mont fw-LM fs-14 text-darkgrey d-flex gap-2 mt-4">
							<div>
								<img src="../../../../assets/img/aiInterview/dots.svg" alt="" />
							</div>
							<div>
								To take this interview, please make sure you're in a quiet
								environment with a stable internet connection.
							</div>
						</div>
					</div>
					<hr id="hideinlaptop" />
					<div id="hideinlaptop" class="d-flex justify-content-center">
						<b-button class="candash-addBtn" @click="confirmAndProceed">
							Confirm & Proceed
						</b-button>
					</div>
				</div>
			</div>
			<div
				class="d-flex align-items-center justify-content-end vr-footer"
				id="hideinmobile"
			>
				<b-button
					@click="stopVideoStream(), $router.go(-1)"
					class="candash-cancelBtn mr-4"
					>Cancel</b-button
				><b-button
					class="candash-customBtn-vr"
					@click="goToNext()"
					:disabled="isDisabled() || (isFromAiInterview && continueLoading)"
				>
					<b-spinner
						v-if="isFromAiInterview && continueLoading"
						small
						class="mr-2"
					></b-spinner>
					Continue
				</b-button>
			</div>
			<div class="d-flex align-items-center gap-3 vr-footer" id="hideinlaptop">
				<div class="mob-addBtn position-relative w-50">
					<b-button @click="gobcktoPreviewMobile()" class="w-100"
						>Cancel</b-button
					>
				</div>

				<div class="mob-cancelBtn w-50">
					<b-button
						@click="goToNext()"
						:disabled="isDisabled() || continueLoading"
						class="w-100"
					>
						<b-spinner v-if="continueLoading" small class="mr-2"></b-spinner>
						Continue
					</b-button>
				</div>
			</div>
		</div>

		<HelpSection v-if="!isFromAiInterview" :referalCode="referalCode" />
		<b-modal
			id="systemcheckmodal"
			size="md"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="d-flex">
				<div class="w-100">
					<div class="candash-modal-top no-border-bottom p-3">
						<div class="width-10">
							<img
								class="mr-3"
								src="../../../../assets/videoresume/captureerror.svg"
								alt=""
							/>
						</div>
						<div class="pl-3 w87">
							<div class="d-flex justify-content-between">
								<div class="candash-modal-head">Alert !</div>

								<div
									class="d-flex justify-content-end pointer cross-icon-pos"
									@click="$bvModal.hide('systemcheckmodal')"
								>
									<img
										class="rotate-on-hover"
										src="../../../../assets/newdesign/dashboard/blueCross.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="candash-modal-label mt-2">
								<div class="newmodal-body-content-ques mt-2">
									It seems you have made changes in your
									<b>"System Permissions"</b>
								</div>
								<div class="newmodal-body-content">
									Kindly reload the page and give the required permissions.
								</div>
							</div>
						</div>
					</div>

					<div class="d-flex justify-content-center p-3">
						<b-button
							@click="$bvModal.hide('systemcheckmodal')"
							class="candash-addBtn"
							variant="outline-primary"
							>Okay</b-button
						>
					</div>
				</div>
			</div>
		</b-modal>
		<PaymentComingSoonModal :showModal.sync="showPaymentComingSoonModal" />
	</div>
</template>

<script>
import HelpSection from "../../../../views/Dashboard/components/HelpSection.vue";
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";
import { mapGetters } from "vuex";
import { startMockInterview } from "@/utils/apiFunctions";
import { Capacitor } from "@capacitor/core";
import { Camera } from "@capacitor/camera";

export default {
	name: "systemCheck",
	components: {
		HelpSection,
		PaymentComingSoonModal,
	},
	data() {
		return {
			isLaptop: true,
			showRules: true,
			referalCode: null,
			stream: undefined,
			audiostream: null,
			audioContext: null,
			toggle: null,
			AudioId: "",
			selectedMic: "",
			SpeakerId: "",
			selectedSpeaker: "",
			VideoId: "",
			selectedCamera: "",
			camera: false,
			mic: false,
			speaker: false,
			disabled: false,
			cameraButton: false,
			audioButton: false,
			deviceSelection: {},
			audiodeviceselection: {},
			audioutputdevice: {},
			canvasContext: {},
			analyserNode: {},
			AudioDevice: [],
			OutputDevice: [],
			VideoDevice: [],
			cameraActive: false,
			micActive: false,
			speakerActive: false,
			continueLoading: false,
			isMacOrIOS: false,
			showPaymentComingSoonModal: false,
		};
	},
	mounted() {
		window.addEventListener("beforeunload", this.stopVideoStream);

		this.checkScreenSize(); // Check screen size initially
		window.addEventListener("resize", this.checkScreenSize);
		this.askCameraPermission();
	},
	beforeUnmount() {
		window.removeEventListener("resize", this.checkScreenSize); // Remove event listener before component unmounts
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.stopVideoStream);
		this.stopVideoStream();
	},
	created() {
		this.isMacOrIOS = /Macintosh|iPhone|iPad|iPod/.test(navigator.userAgent);
		// this.askCameraPermission();
		console.log(this.candidateInfoState, "vuex");
	},
	watch: {
		getSelectedSkillsForInterview(value) {
			console.log(this.selectedSkillsForInterview, "watch");
			if (value) {
				this.selectedSkillsForInterview = value;
			}
		},
	},
	computed: {
		...mapGetters("candidateVUEX", {
			candidateInfoState: "getcandidateInfo",
			selectedSkillsForInterview: "getSelectedSkillsForInterview",
			selectedCompany: "getSelectedCompany",
		}),
		isFromAiInterview() {
			return (
				this.$route.query.fromAiInterview === "true" ||
				this.$route.query.fromAiInterview === true
			);
		},
	},
	methods: {
		confirmAndProceed() {
			this.showRules = false;
		},
		checkScreenSize() {
			this.isLaptop = window.innerWidth >= 1024;
		},
		toggleSpeaker() {
			if (!this.OutputDevice.length) {
				this.getAudioDevices();
			} else {
				this.stoppaudioStream();
				this.OutputDevice = [];
			}
		},
		toggleCamera() {
			if (!this.VideoDevice.length) {
				this.askCameraPermission();
			} else {
				this.stopVideoStream();
				this.VideoDevice = [];
			}
		},
		toggleMic() {
			if (!this.AudioDevice.length) {
				this.getAudioDevices();
			} else {
				this.stoppaudioStream();
				this.AudioDevice = [];
			}
		},
		hideCamera() {
			this.camera = false;
		},
		hideMic() {
			this.mic = false;
		},
		hideSpeaker() {
			this.speaker = false;
		},
		isDisabled() {
			return (
				this.VideoDevice.length === 0 ||
				this.AudioDevice.length === 0 ||
				(this.OutputDevice.length === 0 && !this.isMacOrIOS)
			);
		},
		async startAudioStream() {
			this.audioButton = !this.audioButton; // Toggle the cameraButton property to indicate whether the camera stream is active or not.
			try {
				// Try to access the user's media devices (e.g., webcam) to get a video stream.
				// The 'this.deviceSelection' likely represents the selected video device.
				// Note: 'getUserMedia' is an asynchronous function, so we use 'await' with 'async' keyword here.
				console.log("audio devices",this.audiodeviceselection)
				navigator.mediaDevices
					.getUserMedia({
						audio: this.audiodeviceselection,
					})
					.then(() => {
						this.getAudioDevices();
					}).catch((err)=>console.log("error in start audion start catch", err));
			} catch (e) {
				console.log("sstartAudioStream ome error",e);
			}
		},

		// This function is responsible for starting the video stream from the user's media devices.
		startStream: async function () {
			this.cameraButton = !this.cameraButton; // Toggle the cameraButton property to indicate whether the camera stream is active or not.
			try {
				// Try to access the user's media devices (e.g., webcam) to get a video stream.
				// The 'this.deviceSelection' likely represents the selected video device.
				// Note: 'getUserMedia' is an asynchronous function, so we use 'await' with 'async' keyword here.
				console.log("device selection",this.deviceSelection)
				navigator.mediaDevices
					.getUserMedia({
						video: this.deviceSelection,
					})
					.then((stream) => {
						this.$refs.camera.srcObject = stream; // If successful, set the obtained stream as the source object for the 'this.$refs.camera' element.
						window.localVideoStream = stream; // Store the stream object in a global variable for later access (if needed).
						this.getCameraDevice();
					}).catch((err)=>console.log("error in startstream catch",err));
			} catch (e) {
				console.log("startStream some error", e);
			}
		},

		// This function is responsible for asking the permission for accessing audio and video.
		async askCameraPermission() {
			this.referalCode = this.candidateInfoState.referalCode;
			try {
				console.log("the referal code is " + this.referalCode);
				// On native (Android/iOS), request camera permission via Capacitor before getUserMedia
				if (Capacitor.isNativePlatform()) {
					await Camera.requestPermissions({ permissions: ["camera"] });
				}
				await navigator.mediaDevices.getUserMedia({
					video: true,
					audio: true,
				});
				this.cameraActive = true;
				this.active = true;
				console.log("Camera permission granted.");
				this.startStream();
				this.startAudioStream();
			} catch (err) {
			console.log("askCameraPermission access denied",err)
				this.cameraActive = false;
				this.loader = false;
			}
		},

		getCameraDevice() {
			this.VideoDevice = [];
			navigator.mediaDevices.enumerateDevices().then((devices) => {
				console.log("devices",devices)
				devices.forEach((device) => {
					//This condition fetches all the video devices attached to the system
					if (device.kind === "videoinput") {
						this.VideoDevice.push({
							value: device.deviceId,
							text: device.label,
						});
						this.VideoId = this.VideoDevice[0].value;
						this.selectedCamera = this.VideoDevice[0].text;
					}
				});
				this.loader = false;
			}).catch((err)=>{
				console.log("get camera error",err)
			});
		},

		getAudioDevices() {
			this.AudioDevice = [];
			this.OutputDevice = [];
			navigator.mediaDevices.enumerateDevices().then((devices) => {
				devices.forEach((device) => {
					if (this.isMacOrIOS && device.kind === "audiooutput") {
						return;
					}
					//This condition fetches all the audio devices attached to the system
					if (device.kind === "audioinput") {
						this.AudioDevice.push({
							value: device.deviceId,
							text: device.label,
						});
						this.AudioId = this.AudioDevice[0].value;
						this.selectedMic = this.AudioDevice[0].text;
						this.micActive = true;
					}
					//This condition fetches all the speakers attached to the system
					if (device.kind === "audiooutput" && !this.isMacOrIOS) {
						this.OutputDevice.push({
							value: device.deviceId,
							text: device.label,
						});
						this.SpeakerId = this.OutputDevice[0].value;
						this.selectedSpeaker = this.OutputDevice[0].text;
						this.speakerActive = true;
					}
				});
				this.loader = false;
			});
		},
		handleSuccess(data) {
			this.selectedCamera = data.text;
			const video = document.querySelector("video"); // Get a reference to the video element on the webpage.
			var camerasList = document.querySelector("#cameras-list"); // Get a reference to the cameras-list element on the webpage.
			var selected = camerasList.value; // Get the selected value (camera device ID) from the cameras-list dropdown.

			// Set the deviceSelection property based on the selected value from the dropdown.
			// If a specific camera is selected (selected has a value), use the deviceId in the deviceSelection.
			// Otherwise, use true in the deviceSelection, which may indicate using the default camera.
			this.deviceSelection = selected
				? { deviceId: selected }
				: { facingMode: "user" };

			navigator.mediaDevices.getUserMedia({
				// Attempt to get access to the user's media devices (e.g., webcam) using getUserMedia.
				video: this.deviceSelection,
			});

			// After obtaining access to the media devices, try to get the video stream again with getUserMedia.
			// This time, we use a 'then' callback to handle the success case.
			navigator.mediaDevices
				.getUserMedia({
					video: this.deviceSelection,
				})
				.then(function (stream) {
					// If the getUserMedia call is successful, the 'stream' object represents the video stream.
					// Set the 'srcObject' property of the 'video' element to display the video feed.
					video.srcObject = stream;
				});
			this.camera = false;
		},
		handleSuccessaudio(data) {
			if (this.mic) {
				this.selectedMic = data.text;
			}
			var micselected = this.selectedMic; // Get the selected value (microphone device ID) from the mic-list dropdown.

			// Set the audiodeviceselection property based on the selected value from the dropdown.
			// If a specific microphone is selected (micselected has a value),
			// use the deviceId in the audiodeviceselection.
			// Otherwise, use true in the audiodeviceselection, which may indicate using the default microphone.
			this.audiodeviceselection = micselected
				? { deviceId: micselected }
				: true;

			// Attempt to get access to the user's audio input devices (e.g., microphones) using getUserMedia.
			// Note: This call doesn't handle the audio stream; it just tries to get access.
			navigator.mediaDevices.getUserMedia({
				audio: this.audiodeviceselection,
			});
			this.mic = false;
		},
		speakeroutput(data) {
			if (this.speaker) {
				this.selectedSpeaker = data.text;
			}
			var speakerselected = this.selectedSpeaker; // Get the selected value (speaker output device ID) from the speaker-list dropdown.

			// Set the audioutputdevice property based on the selected value from the dropdown.
			// If a specific speaker output device is selected (speakerselected has a value),
			// use the deviceId in the audioutputdevice.
			// Otherwise, use true in the audioutputdevice, which may indicate using the default speaker.
			this.audioutputdevice = speakerselected
				? { deviceId: speakerselected }
				: true;
			this.speaker = false;
		},
		startAudioCheck: async function () {
			try {
				//this.recordedUrl = null;
				// Request access to the user's audio input using getUserMedia.
				// The "audio" constraint is set based on the "audiodeviceselection" parameter.
				this.audiostream = await navigator.mediaDevices.getUserMedia({
					audio: this.audiodeviceselection,
				});
				// If audio access is granted, proceed with the following actions:
				// Handle the logic for a successful audio stream acquisition.
				this.handleSuccessaudio();

				this.speakeroutput(); // Handle the configuration of the audio output, if required.
				this.Checkaudio(); // Check the properties or capabilities of the obtained audio stream.
			} catch (e) {
				// console.log(e);
			}
		},
		Checkaudio() {
			try {
				// Initialize the audio context
				this.audioContext = new window.AudioContext();

				// Get microphone input
				const microphoneInput = this.audioContext.createMediaStreamSource(
					this.audiostream
				);

				const audioOutput = this.audioContext.destination;
				microphoneInput.connect(audioOutput);
				this.canvasContext = this.$refs.waveformCanvas.getContext("2d");
				this.analyserNode = this.audioContext.createAnalyser();
				microphoneInput.connect(this.analyserNode);
				this.drawWaveform();
				this.disabled = true;
			} catch (error) {
				console.error("Error starting test:", error);
			}
		},
		drawWaveform() {
			const bufferLength = this.analyserNode.fftSize;
			const dataArray = new Uint8Array(bufferLength);
			const canvasWidth = this.$refs.waveformCanvas.width;
			const canvasHeight = this.$refs.waveformCanvas.height;
			const sliceWidth = canvasWidth / bufferLength;
			this.canvasContext.clearRect(0, 0, canvasWidth, canvasHeight);

			const draw = () => {
				this.analyserNode.getByteTimeDomainData(dataArray);

				this.canvasContext.fillStyle = "rgb(255, 255, 255)";
				this.canvasContext.fillRect(0, 0, canvasWidth, canvasHeight);

				this.canvasContext.lineWidth = 2;
				this.canvasContext.strokeStyle = "green";
				this.canvasContext.beginPath();

				let x = 0;

				for (let i = 0; i < bufferLength; i++) {
					// Scale the amplitude to fit within the canvas height
					const y = (dataArray[i] / 128.0) * canvasHeight;

					if (i === 0) {
						this.canvasContext.moveTo(x, y);
					} else {
						this.canvasContext.lineTo(x, y);
					}

					x += sliceWidth;
				}

				this.canvasContext.stroke();
			};

			this.drawInterval = setInterval(draw, 1000 / 60); // 60 frames per second
		},
		stoppaudioStream() {
			clearInterval(this.drawInterval);
			if (this.audioContext) {
				this.audioContext.close();
			}
			if (this.audiostream) {
				this.audiostream.getTracks().forEach((track) => track.stop());
			}
			this.disabled = false;
		},
		async goToNext() {
			this.stoppaudioStream();
			const isCameraGranted = await this.checkPermissionGranted("camera");
			const isMicroGranted = await this.checkPermissionGranted("microphone");
			if (!isCameraGranted || !isMicroGranted) {
				this.isDisabled();
				this.$bvModal.show("systemcheckmodal");
			} else {
				if (this.isFromAiInterview) {
					this.continueLoading = true;
					console.log(
						"this.selectedSkillsForInterview",
						this.selectedSkillsForInterview
					);
					try {
						const transformed = this.selectedSkillsForInterview.map((item) => {
							// Case 1: item is a string → treat it as skillName
							if (typeof item === "string") {
								return {
									skillName: item,
									expertiseLevel: "beginner",
								};
							}

							// Case 2: item is an object → extract fields
							return {
								skillName: item.skillName || item.name || "",
								expertiseLevel:
									item.expertiseLevel ||
									item.expertise_level ||
									item.difficulty ||
									"beginner",
							};
						});
						let payload = {
							skills: transformed,
							duration: 15,
							basedOn: "skill",
						};
						console.log(this.$route.query.bycompany, "byyyyyyyyyyyyy");
						if (this.$route.query.bycompany) {
							payload.basedOn = "company";
							payload.duration = 20;
							payload.company = this.selectedCompany.company_name;
							payload.role = this.selectedCompany.role;
						}
						const response = await startMockInterview(payload);
						this.$router.push({
							name: "InterviewOngoing",
							params: {
								interviewID: response.data.interviewID,
							},
						});
					} catch (error) {
						if (error.response.status === 429) {
							this.showPaymentComingSoonModal = true;
							return;
						}
						console.error("Error starting mock interview:", error);
					} finally {
						this.continueLoading = false;
					}
				} else {
					this.gotoVideoResume();
				}
			}
		},
		async checkPermissionGranted(key) {
			try {
				// On native (Android/iOS), use Capacitor Camera API for camera permission
				if (Capacitor.isNativePlatform()) {
					if (key === "camera") {
						const status = await Camera.checkPermissions();
						return status.camera === "granted";
					}
					if (key === "microphone") {
						// navigator.permissions.query for microphone is unreliable on some WebViews/Native
						// Since we request both permissions together and the user can't proceed without devices,
						// we use Camera permission as a proxy for Microphone.
						const status = await Camera.checkPermissions();
						return status.camera === "granted";
					}
				}
				const permission = await navigator.permissions.query({ name: key });
				if (permission.state === "granted") {
					return true;
				}
				return false;
			} catch (error) {
				return false;
			}
		},
		stopVideoStream() {
			// Check if there's a stream running
			if (window.localVideoStream) {
				const tracks = window.localVideoStream.getTracks();
				tracks.forEach((track) => {
					// Check if track is active
					if (track.readyState === "live") {
						try {
							track.stop(); // Stop the track
							console.log("Track stopped:", track);
						} catch (error) {
							console.error("Error stopping track:", error);
						}
					}
				});
				window.localVideoStream = null; // Clear the stream object
				this.$refs.camera.srcObject = null; // Release the camera resource
				console.log("Video stream stopped successfully.");
			} else {
				console.warn("No video stream to stop.");
			}
		},

		gobcktoPreview() {
			console.log("it is here ");
			this.stopVideoStream();
			this.$router.push({
				name: "CandidateDashboard",
			});
		},
		gobcktoPreviewMobile() {
			this.stopVideoStream();
			this.$router.push({ name: "CandidateDashboard" });
		},
		gotoVideoResume() {
			this.stopVideoStream();
			this.$router.push({
				name: "snapshot",
			});
		},
	},
};
</script>
<style>
.vs-dropdown-container {
	border-radius: 4px;
	border: 1px solid rgba(41, 136, 230, 0.22);
	background: #f9f9f9;
}
.vs-dropdown-text {
	display: inline-flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	padding: 0.375rem 0.75rem;
	color: #3a3c40 !important;
	font-size: 13px !important;
	font-family: "Lato", sans-serif !important;
	font-weight: 500 !important;
	background-color: #f9f9f9;
	border-color: #f9f9f9;
}

.vs-dropdown-text-active {
	color: #3a3c40 !important;
	font-size: 13px !important;
	word-break: break-all;
	font-weight: 500 !important;
	background-color: #c8d9e5 !important;
	border-color: #c8d9e5 !important;
	display: inline-flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	padding: 0.375rem 0.75rem;
}
.vr-candash-tabs-newcard .cand-header {
	background-color: #20639b14;
}
</style>
